import { useCallback } from "react";

import { errorToast } from "~/ui/admin/toast/errorToast";
import { toast } from "~/ui/admin/toast/toast";

export const useCopyToClipboard = () => {
  const copy = useCallback(async (value: string, successTitle: string) => {
    try {
      await navigator.clipboard.writeText(value);
      toast({ type: "success", title: successTitle });
    } catch (error) {
      errorToast(error);
    }
  }, []);

  return { copy };
};
